import { keyframes } from "@edreamsodigeo/prisma-design-system";

const contentKeyframes = keyframes`
  0% {
    opacity: 0;
    transform: translateY(136px);
  }
  50% {
    opacity: 1;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
`;
export const animatedContentStyles = {
  animation: `${contentKeyframes} 1.2s ease-in-out both`,
  animationDelay: "0.3s",
};
